import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { StudentsService } from '../../../api/Services/maintenance/students.service';
import { element } from 'protractor';
import { TabService } from '../../../tabconfig/tab.service';
import { Tab } from '../../../tabconfig/tab.model';
import { StudentCourseTaskComponent } from '../student-course-task/student-course-task.component';

@Component({
  selector: 'app-student-course',
  templateUrl: './student-course.component.html',
  styleUrls: ['./student-course.component.css']
})
export class StudentCourseComponent implements OnInit {

  public displayedColumns: string[] = ['per_vc_document_number', 'per_vc_full_name', 'per_vc_cellphone', 'opcion'];
  public dataSource = new MatTableDataSource<any[]>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('paginatorDatasource', { read: MatPaginator, static: true }) paginator: MatPaginator;

  @Input() data;

  public cousesData: any;

  constructor(
    private studentServices: StudentsService,
    private tabService: TabService
  ) {

  }

  ngOnInit(): void {

    if (this.data.tabData.element) {
      this.cousesData = this.data.tabData.element;
      this.get();
    }


  }

  get() {
    
    this.studentServices.GetAssign(this.cousesData.cou_in_id).subscribe(
      data => {
        console.log(data);

        if (data['sucess']) {
          let result = data['data'];
          console.log(result);
          this.dataSource = new MatTableDataSource<any[]>(result);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
      }
    );
  }

  showFileCourses(element){
    this.tabService.addTab(new Tab(StudentCourseTaskComponent, "Archivos -  "+ element.per_vc_full_name, { parent: 'ListadoComponent', element: element }));
  }
}
